
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institutions/book-a-demo",
      function () {
        return require("private-next-pages/institutions/book-a-demo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institutions/book-a-demo"])
      });
    }
  